import React, { Component } from 'react';

import compose from 'recompose/compose';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

// Shared layouts
import DashboardLayout from 'layouts/Dashboard';
import Activities from './Activities'
import History from './History'
import Schedule from './Schedule'
// Component styles
import styles from './styles';

class Maintenance extends Component {
    constructor(props) {
        //console.log('props periodical', props)
        //console.log(sessionStorage.getItem("listaObjetivosOnline"))
        super(props);
        this.myCallback = this.myCallback.bind(this);
        this.handleInfo = this.handleInfo.bind(this);
        this.state = {
            online:null,
            value: 0,
        }
    }

    myCallback = (dataFromChild) => {
        this.setState({
            objectivesList: dataFromChild
        })
    }
    handleInfo(value) {
        this.setState({
            value: value,
            //updateDisabled: true,
            //alertobjectives: null
        });
    }

    handleChange = (event, newValue) => {
        this.setState({
            value: newValue,
            //updateDisabled: true,
            //alertobjectives: null
        });
    };
    render() {
        const {value}=this.state
        //console.log('period', this.props)
        return (
            <DashboardLayout  title="Mantenimientos"  callbackFromParent={this.myCallback} isFirstTime={false}>
                <AppBar position="static" style={{ backgroundColor: '#333333' ,marginTop:"101px"}}>
                        <Tabs value={value} onChange={this.handleChange} aria-label="simple tabs example">
                            <Tab label="Actividades Programadas" style={{paddingTop:"15px"}} />
                            <Tab label="Historial" style={{paddingTop:"15px"}}/>
                            <Tab label="Agendar" style={{paddingTop:"15px"}}/>
                        </Tabs>
                </AppBar>
                    { value == 0 ? 
                        <Activities/>   
                    : value == 1 ?
                        <History/> 
                    : value==2?
                    <Schedule onInfo={this.handleInfo}/>
                    :null }
            </DashboardLayout>
            
        );
    }
}


export default compose(withWidth(), withStyles(styles))(Maintenance);
